import { render, staticRenderFns } from "./AdminUsersEvents.vue?vue&type=template&id=cc095384&"
import script from "./AdminUsersEvents.vue?vue&type=script&lang=js&"
export * from "./AdminUsersEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports